import { CpCommerceConstants, LayoutNodeTree, PlatformConstants } from '../../sdk';
import * as fromDatatype from '../datatype-library/index';

interface PlatformConfigV1 {
  ios?: LayoutNodeTree,
  android?: LayoutNodeTree,
  mobile?: LayoutNodeTree,
  mobileweb?: LayoutNodeTree,
  iphone?: LayoutNodeTree,
  pwa?: LayoutNodeTree,
  phablet?: LayoutNodeTree,
  ipad?: LayoutNodeTree,
  tablet?: LayoutNodeTree,
  desktop?: LayoutNodeTree,
  electron?: LayoutNodeTree,
  
  /**@deprecated not supported */
  capacitor?: LayoutNodeTree,
  /**@deprecated not supported */
  cordova?: LayoutNodeTree,
  /**@deprecated not supported */
  hybrid?: LayoutNodeTree,
}

interface PlatformConfigJsonDatatypeInterface extends fromDatatype.JsonDatatypeInterface {
  [PlatformConstants.Versions.VERSION_1]?: PlatformConfigV1
}

export interface bl_cms_layout_instance_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  theme_guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  layout_configuration_json: fromDatatype.JsonDatatypeInterface;
  layout_configuration_text: fromDatatype.VarcharDatatypeInterface;
  layout_status: fromDatatype.VarcharDatatypeInterface;
  route_type: fromDatatype.TextDatatypeInterface;
  route_path: fromDatatype.VarcharDatatypeInterface;
  route_name: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  type: CpCommerceConstants.LAYOUT_INSTANCE_TYPE;
  platform_configuration_json: PlatformConfigJsonDatatypeInterface;
  layout_header_guid: fromDatatype.GuidDataFieldInterface;
	layout_footer_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_cms_layout_instance_hdr_RowClass implements bl_cms_layout_instance_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  theme_guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  layout_configuration_json: fromDatatype.JsonDatatypeInterface;
  layout_configuration_text: fromDatatype.VarcharDatatypeInterface;
  layout_status: fromDatatype.VarcharDatatypeInterface;
  route_type: fromDatatype.TextDatatypeInterface;
  route_path: fromDatatype.VarcharDatatypeInterface;
  route_name: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  type: CpCommerceConstants.LAYOUT_INSTANCE_TYPE;
  platform_configuration_json: PlatformConfigJsonDatatypeInterface = {
    [PlatformConstants.Versions.VERSION_1]: {}
  }
  layout_header_guid: fromDatatype.GuidDataFieldInterface;
	layout_footer_guid: fromDatatype.GuidDataFieldInterface;
}

